import { Component, HostBinding, Input, OnInit } from '@angular/core';

import { BuildingBlockInterface } from '../building-block.interface';
import { SpacerComponentContext } from './spacer-context.interface';

@Component({
    selector: 'app-spacer',
    template: '',
    styles: [':host {display: block;}'],
})
export class SpacerComponent implements BuildingBlockInterface, OnInit {
    @Input() public context: SpacerComponentContext;
    @HostBinding('style.height') public height: string;
    public paddingEnabled = false;

    public ngOnInit(): void {
        this.height = this.context.height + 'rem';
    }
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/spacer/spacer.component.ts